import React, { useState, useEffect, useRef } from "react";
import Chrome from "react-color";
import Lottie from "lottie-web";

var skinparts, get2, PartsName;

var FemaleBodyParts = [
  {
    name: "Bottom",
    parts: [
      "Hip_Comp",
      "L_Thigh_Comp",
      "R_Thigh_Comp",
      "L_Calf_Comp",
      "R_Calf_Comp",
    ],
  },

  {
    name: "LowerTop",
    parts: [
      "BaseBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp ",
      "R_Wing_Comp",
    ],
  },

  {
    name: "MiddleTop",
    parts: [
      "MiddleBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp ",
      "R_Wing_Comp",
    ],
  },

  {
    name: "OuterTop",
    parts: [
      "OuterBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "CoatSide_Comp",
      "L_Wing_Comp ",
      "R_Wing_Comp",
    ],
  },

  { name: "Shoe", parts: ["L_Foot_Comp", "R_Foot_Comp"] },

  { name: "Eye", parts: ["Eye_Comp"] },

  { name: "Nose", parts: ["Nose_Comp"] },

  { name: "EyeBrow", parts: ["EyeBrow_Comp"] },

  { name: "Ear", parts: ["Ear_Comp"] },

  { name: "Hair", parts: ["SideHair_Comp", "FrontHair_Comp", "BackHair_Comp"] },

  { name: "Mouth", parts: ["Mouth_Comp"] },

  { name: "Face", parts: ["Face_Comp"] },

  { name: "BaseBody", parts: ["BaseBody_Comp"] },

  { name: "Cap", parts: ["Cap_Comp"] },

  { name: "Mask", parts: ["Mask_Comp"] },

  { name: "Glasses", parts: ["Glasses_Comp"] },

  { name: "EarWear", parts: ["EarWear_Comp"] },
];

var MaleBodyParts = [
  {
    name: "Bottom",
    parts: [
      "Hip_Comp",
      "L_Thigh_Comp",
      "R_Thigh_Comp",
      "L_Calf_Comp",
      "R_Calf_Comp",
    ],
  },

  {
    name: "LowerTop",
    parts: [
      "BaseBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  {
    name: "MiddleTop",
    parts: [
      "MiddleBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  {
    name: "OuterTop",
    parts: [
      "OuterBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  { name: "Shoe", parts: ["L_Foot_Comp", "R_Foot_Comp"] },

  { name: "Eye", parts: ["Eye_Comp"] },

  { name: "Nose", parts: ["Nose_Comp"] },

  { name: "EyeBrow", parts: ["EyeBrow_Comp"] },

  { name: "Ear", parts: ["Ear_Comp"] },

  { name: "Hair", parts: ["SideHair_Comp", "FrontHair_Comp", "BackHair_Comp"] },

  { name: "Mouth", parts: ["Mouth_Comp"] },

  { name: "Face", parts: ["Face_Comp"] },

  { name: "BaseBody", parts: ["BaseBody_Comp"] },

  { name: "Cap", parts: ["Cap_Comp"] },

  { name: "Mask", parts: ["Mask_Comp"] },

  { name: "Glasses", parts: ["Glasses_Comp"] },

  { name: "EarWear", parts: ["EarWear_Comp"] },
];

var DefaultColors = [
  { color: "#ffffff" },
  { color: "#F7D6B7" },
  { color: "#007bff" },
  { color: "#ffc107" },
  { color: "#28a745" },
  { color: "#17a2b8" },
  { color: "#f44336" },
  { color: "#e91e63" },
  { color: "#9c27b0" },
  { color: "#673ab7" },
  { color: "#3f51b5" },
  { color: "#03a9f4" },
  { color: "#ff9800" },
  { color: "#795548" },
  { color: "#9e9e9e" },
  { color: "#607d8b" },
  { color: "#009688" },
  { color: "#343a40" },
];

var SkinDefaultColors = [
  { color: "#E6BCA6" },
  { color: "#f1c27d" },
  { color: "#e0ac69" },
  { color: "#c68642" },
  { color: "#8d5524" },
  { color: "#592f2a" },
  { color: "#ffe0bd" },
  { color: "#ffcd94" },
  { color: "#eac086" },
  { color: "#ffe39f" },
  { color: "#ffad60" },
  { color: "#fe9430" },
  { color: "#c58c85" },
  { color: "#5dd5a5" },
  { color: "#4fa7ff" },
  { color: "#7181ca" },
  { color: "#ff5e99" },
  { color: "#676571" },
];

const PopColorPicker = (props) => {
  const [AdvanceColors, setAdvanceColors] = useState(false);

  const [ChrColorPicker, setChrColorPicker] = useState(false);

  const [left, setleft] = useState(0);

  const [rgba, setrgba] = useState("rgb(255, 255, 255)");

  const [ShadeName, setShadeName] = useState("");

  const focusDiv = useRef(null);

  useEffect(() => {
    if (props.Gender === "Male") {
      skinparts = [
        "Neck_Comp",
        "R_Hand_Comp",
        "Ear_Comp",
        "L_Hand_Comp",
        "Face_Comp",
        "Torso_Comp",
        "L_Thigh_Comp",
        "R_Thigh_Comp",
        "L_Calf_Comp",
        "R_Calf_Comp",
        "BaseBody_Comp",
        "OuterBody_Comp",
        "MiddleBody_Comp",
        "L_Arm_Comp",
        "R_Arm_Comp",
        "L_ForeArm_Comp",
        "R_ForeArm_Comp",
        "L_Foot_Comp",
        "R_Foot_Comp",
        "Nose_Comp",
        "Eye_Comp",
        "Mouth_Comp",
        "Left_Shoulder",
        "Right_Shoulder",
        "L_Wing_Comp",
        "R_Wing_Comp",
      ];
    } else if (props.Gender === "Female") {
      skinparts = [
        "Neck_Comp",
        "R_Hand_Comp",
        "Ear_Comp",
        "L_Hand_Comp",
        "Face_Comp",
        "Torso_Comp",
        "L_Thigh_Comp",
        "R_Thigh_Comp",
        "L_Calf_Comp",
        "R_Calf_Comp",
        "BaseBody_Comp",
        "OuterBody_Comp",
        "MiddleBody_Comp",
        "L_Arm_Comp",
        "R_Arm_Comp",
        "L_ForeArm_Comp",
        "R_ForeArm_Comp",
        "L_Foot_Comp",
        "R_Foot_Comp",
        "Nose_Comp",
        "Eye_Comp",
        "Mouth_Comp",
        "Left_Shoulder",
        "Right_Shoulder",
        "L_Wing_Comp",
        "R_Wing_Comp",
      ];
    }
  }, [props.Gender]);

  const CharClrChange = (params, picker) => {
    let json = props.CharacterJson;
    var colors;

    if (picker === false) {
      colors = params.target.attributes.style.value.split("(");
    } else if (picker === true) {
      colors = params.split("(");
    }

    var changeColor = colors[1].split(")");
    var rgbArray = changeColor[0].split(",");
    var rgbConverted = [],
      DarkRgbConverted = [],
      LiteRgbConverted = [],
      NoseShades = [],
      NeckShades = [];

    for (var z = 0; z < rgbArray.length; z++) {
      //convert rbg into the json rgb
      rgbConverted.push(rgbArray[z] / 25 / 10);
    }

    var NeckDiff = [15, 17, 16],
      NoseDiff = [40, 60, 80];

    for (let Ns = 0; Ns < rgbArray.length; Ns++) {
      NoseShades.push(rgbArray[Ns] - NoseDiff[Ns]);
    }

    for (let Neck = 0; Neck < rgbArray.length; Neck++) {
      NeckShades.push(rgbArray[Neck] - NeckDiff[Neck]);
    }

    for (var Dshd = 0; Dshd < NoseShades.length; Dshd++) {
      //convert rbg into the json rgb
      DarkRgbConverted.push(NoseShades[Dshd] / 25 / 10);
    }

    for (var Lshd = 0; Lshd < NeckShades.length; Lshd++) {
      //convert rbg into the json rgb
      LiteRgbConverted.push(NeckShades[Lshd] / 25 / 10);
    }

    for (var diff = 0; diff < json.assets.length; diff++) {
      if (json.assets[diff].id === "comp_0") {
        for (var Layr = 0; Layr < json.assets[diff].layers.length; Layr++) {
          for (var x = 0; x < skinparts.length; x++) {
            if (json.assets[diff].layers[Layr].nm === skinparts[x]) {
              if (json.assets[diff].layers[Layr].nm === "Nose_Comp") {
                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b < json.assets[diff].layers[Layr].layers[a].shapes.length;
                    b++
                  ) {
                    if (
                      json.assets[diff].layers[Layr].layers[a].shapes[b].it !=
                      undefined
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers[Layr].layers[a].shapes[b].it
                          .length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it[
                            c
                          ].ty === "fl"
                        ) {
                          for (let d = 0; d < DarkRgbConverted.length; d++) {
                            json.assets[diff].layers[Layr].layers[a].shapes[
                              b
                            ].it[c].c.k[d] = DarkRgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }
              }

              if (json.assets[diff].layers[Layr].nm === "Mouth_Comp") {
                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  if (
                    json.assets[diff].layers[Layr].layers[a].shapes != undefined
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[a].shapes.length;
                      b++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[a].shapes[
                          b
                        ].nm.split("_")[0] === "Changeable"
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < DarkRgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[a].shapes[
                                b
                              ].it[c].c.k[d] = DarkRgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              if (
                json.assets[diff].layers[Layr].nm === "Neck_Comp" ||
                json.assets[diff].layers[Layr].nm === "Ear_Comp"
              ) {
                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b < json.assets[diff].layers[Layr].layers[a].shapes.length;
                    b++
                  ) {
                    if (
                      json.assets[diff].layers[Layr].layers[a].shapes[
                        b
                      ].nm.split("_")[0] === "Changeable"
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers[Layr].layers[a].shapes[b].it
                          .length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it[
                            c
                          ].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers[Layr].layers[a].shapes[
                              b
                            ].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    } else {
                      if (
                        json.assets[diff].layers[Layr].layers[a].shapes[b].it !=
                        undefined
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < LiteRgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[a].shapes[
                                b
                              ].it[c].c.k[d] = LiteRgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              if (json.assets[diff].layers[Layr].nm === "Eye_Comp") {
                if (props.Gender === "Male" || props.Gender === "Female") {
                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    if (
                      json.assets[diff].layers[Layr].layers[a].nm === "Skin" ||
                      json.assets[diff].layers[Layr].layers[a].nm ===
                        "Shape Layer 1"
                    ) {
                      for (
                        let b = 0;
                        b <
                        json.assets[diff].layers[Layr].layers[a].shapes.length;
                        b++
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < rgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[a].shapes[
                                b
                              ].it[c].c.k[d] = rgbConverted[d];
                            }
                          }
                        }
                      }
                    } else {
                      //I have added this as child structure of comp of Female is different than male
                      if (props.Gender === "Male") {
                        for (
                          let b = 0;
                          b <
                          json.assets[diff].layers[Layr].layers[a].shapes
                            .length;
                          b++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .nm === "Skin" ||
                            json.assets[diff].layers[Layr].layers[a].nm ===
                              "Shape Layer 1"
                          ) {
                            if (
                              json.assets[diff].layers[Layr].layers[a].shapes[b]
                                .it != undefined
                            ) {
                              for (
                                let c = 0;
                                c <
                                json.assets[diff].layers[Layr].layers[a].shapes[
                                  b
                                ].it.length;
                                c++
                              ) {
                                if (
                                  json.assets[diff].layers[Layr].layers[a]
                                    .shapes[b].it[c].ty === "fl"
                                ) {
                                  for (
                                    let d = 0;
                                    d < rgbConverted.length;
                                    d++
                                  ) {
                                    json.assets[diff].layers[Layr].layers[
                                      a
                                    ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      //I have added this as child structure of comp of Female is different than male
                      else {
                        for (
                          let x = 0;
                          x <
                          json.assets[diff].layers[Layr].layers[a].layers
                            .length;
                          x++
                        ) {
                          for (
                            let b = 0;
                            b <
                            json.assets[diff].layers[Layr].layers[a].layers[x]
                              .shapes.length;
                            b++
                          ) {
                            if (
                              json.assets[diff].layers[Layr].layers[a].layers[x]
                                .shapes[b].nm === "Skin" ||
                              json.assets[diff].layers[Layr].layers[a].nm ===
                                "Shape Layer 1"
                            ) {
                              if (
                                json.assets[diff].layers[Layr].layers[a].layers[
                                  x
                                ].shapes[b].it != undefined
                              ) {
                                for (
                                  let c = 0;
                                  c <
                                  json.assets[diff].layers[Layr].layers[a]
                                    .layers[x].shapes[b].it.length;
                                  c++
                                ) {
                                  if (
                                    json.assets[diff].layers[Layr].layers[a]
                                      .layers[x].shapes[b].it[c].ty === "fl"
                                  ) {
                                    for (
                                      let d = 0;
                                      d < rgbConverted.length;
                                      d++
                                    ) {
                                      json.assets[diff].layers[Layr].layers[
                                        a
                                      ].layers[x].shapes[b].it[c].c.k[d] =
                                        rgbConverted[d];
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                // I have commented this as there is not parent comp differnce of Eye structure of Male and female
                // else if (props.Gender === 'Female') {

                //     for (let a = 0; a < json.assets[diff].layers[Layr].layers.length; a++) {

                //         for (let b = 0; b < json.assets[diff].layers[Layr].layers[a].layers.length; b++) {
                //             if (json.assets[diff].layers[Layr].layers[a].layers[b].nm === 'EyeLesh') {

                //                 for (let c = 0; c < json.assets[diff].layers[Layr].layers[a].layers[b].shapes.length; c++) {

                //                     for (let d = 0; d < json.assets[diff].layers[Layr].layers[a].layers[b].shapes[c].it.length; d++) {
                //                         if (json.assets[diff].layers[Layr].layers[a].layers[b].shapes[c].it[d].ty === "fl") {
                //                             for (let e = 0; e < rgbConverted.length; e++) {
                //                                 json.assets[diff].layers[Layr].layers[a].layers[b].shapes[c].it[d].c.k[e] = rgbConverted[e]
                //                             }
                //                         }
                //                     }
                //                 }
                //             }
                //         }
                //     }
                // }
              }

              if (json.assets[diff].layers[Layr].nm === "Face_Comp") {
                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b < json.assets[diff].layers[Layr].layers[a].shapes.length;
                    b++
                  ) {
                    for (
                      let c = 0;
                      c <
                      json.assets[diff].layers[Layr].layers[a].shapes[b].it
                        .length;
                      c++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[a].shapes[b].it[c]
                          .ty === "fl"
                      ) {
                        for (let d = 0; d < rgbConverted.length; d++) {
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it[
                            c
                          ].c.k[d] = rgbConverted[d];
                        }
                      }
                    }
                  }
                }
              }

              if (
                json.assets[diff].layers[Layr].nm === "L_Thigh_Comp" ||
                json.assets[diff].layers[Layr].nm === "R_Thigh_Comp"
              ) {
                let lastLayer =
                  json.assets[diff].layers[Layr].layers.length - 1;

                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b <
                    json.assets[diff].layers[Layr].layers[lastLayer].shapes
                      .length;
                    b++
                  ) {
                    if (
                      json.assets[diff].layers[Layr].layers[lastLayer].shapes[b]
                        .nm === "N_Thigh"
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers[Layr].layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers[Layr].layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                  break;
                }
              }

              if (
                json.assets[diff].layers[Layr].nm === "L_Foot_Comp" ||
                json.assets[diff].layers[Layr].nm === "R_Foot_Comp"
              ) {
                if (props.Gender == "Female") {
                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[a].shapes.length;
                      b++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[a].shapes[b]
                          .nm === "Shoe_Skin"
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < rgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[a].shapes[
                                b
                              ].it[c].c.k[d] = rgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                  }
                }
                var LL = json.assets[diff].layers[Layr].layers.length - 1;

                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b < json.assets[diff].layers[Layr].layers[LL].shapes.length;
                    b++
                  ) {
                    for (
                      let c = 0;
                      c <
                      json.assets[diff].layers[Layr].layers[LL].shapes[b].it
                        .length;
                      c++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[LL].shapes[b].it[
                          c
                        ].ty === "fl"
                      ) {
                        for (let d = 0; d < rgbConverted.length; d++) {
                          json.assets[diff].layers[Layr].layers[LL].shapes[
                            b
                          ].it[c].c.k[d] = rgbConverted[d];
                        }
                      }
                    }
                  }
                }
              }

              if (
                json.assets[diff].layers[Layr].nm !== "Nose_Comp" &&
                json.assets[diff].layers[Layr].nm !== "Neck_Comp" &&
                json.assets[diff].layers[Layr].nm !== "Eye_Comp" &&
                json.assets[diff].layers[Layr].nm !== "Mouth_Comp" &&
                json.assets[diff].layers[Layr].nm !== "L_Thigh_Comp" &&
                json.assets[diff].layers[Layr].nm !== "R_Thigh_Comp" &&
                json.assets[diff].layers[Layr].nm !== "Ear_Comp" &&
                json.assets[diff].layers[Layr].nm !== "Face_Comp" &&
                json.assets[diff].layers[Layr].nm !== "L_Foot_Comp" &&
                json.assets[diff].layers[Layr].nm !== "R_Foot_Comp"
              ) {
                let lastLayer =
                  json.assets[diff].layers[Layr].layers.length - 1;
                for (
                  let a = 0;
                  a < json.assets[diff].layers[Layr].layers.length;
                  a++
                ) {
                  for (
                    let b = 0;
                    b <
                    json.assets[diff].layers[Layr].layers[lastLayer].shapes
                      .length;
                    b++
                  ) {
                    for (
                      let c = 0;
                      c <
                      json.assets[diff].layers[Layr].layers[lastLayer].shapes[b]
                        .it.length;
                      c++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[lastLayer].shapes[
                          b
                        ].it[c].ty === "fl"
                      ) {
                        for (let d = 0; d < rgbConverted.length; d++) {
                          json.assets[diff].layers[Layr].layers[
                            lastLayer
                          ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    const ctx = document.getElementsByClassName("ChrClass")[0].getContext("2d");

    var currFrame = props.Play.currentFrame;
    Lottie.destroy("alex");
    get2 = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: json,

      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
        //className: 'CharCanv',
      },
    });

    get2.goToAndPlay(currFrame, true, "alex");

    props.setPlay(get2);

    let arr = [];

    for (let clrc = 0; clrc < 3; clrc++) {
      arr.push(rgbArray[clrc]);
    }
    props.colorPickers.colorShades.Shades = [];
    props.colorPickers.colorShades.Shades.push(arr);
    setrgba("rgb(" + rgbArray[0] + "," + rgbArray[1] + "," + rgbArray[2] + ")");
  };

  const openpicker = (params, name, r, g, b) => {
    var targetleft = params.target.getBoundingClientRect().x;

    var parentLeft =
      params.target.offsetParent.offsetParent.getBoundingClientRect().x;

    //left = Math.round(targetleft) - Math.round(parentLeft) - 26

    setChrColorPicker(true);

    setleft(Math.round(targetleft) - Math.round(parentLeft) - 26);

    setrgba("rgb(" + r + "," + g + "," + b + ")");

    setAdvanceColors(false);

    setShadeName(name);
  };

  const partColor = (params, picker) => {
    let json = props.CharacterJson;

    var colors;

    if (picker === undefined) {
      colors = params.target.attributes.style.value.split("(");
    } else if (picker === true) {
      colors = params.split("(");
    }
    var changeColor = colors[1].split(")");
    var rgbArray = changeColor[0].split(",");

    var Name = props.colorPickers.data;

    var rbgConverted = [];

    for (let c = 0; c < rgbArray.length; c++) {
      //convert rbg into the json rgb
      rbgConverted.push(parseInt(rgbArray[c]) / 25 / 10);
    }

    var NewName = props.colorPickers.data.split("_")[0];

    if (props.Gender === "Female") {
      for (let a = 0; a < FemaleBodyParts.length; a++) {
        if (FemaleBodyParts[a].name === NewName) {
          PartsName = FemaleBodyParts[a].parts;
        }
      }
    } else if (props.Gender === "Male") {
      for (let a = 0; a < MaleBodyParts.length; a++) {
        if (MaleBodyParts[a].name === NewName) {
          PartsName = MaleBodyParts[a].parts;
        }
      }
    }

    for (let b = 0; b < json.assets.length; b++) {
      if (json.assets[b].id === "comp_0") {
        for (let c = 0; c < json.assets[b].layers.length; c++) {
          for (let d = 0; d < PartsName.length; d++) {
            if (json.assets[b].layers[c].nm === PartsName[d]) {
              if (PartsName[d] === "Eye_Comp") {
                if (props.Gender === "Female") {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c].layers.length;
                    e++
                  ) {
                    if (json.assets[b].layers[c].layers[e].nm == Name) {
                      for (
                        let ind = 0;
                        ind < json.assets[b].layers[c].layers[e].layers.length;
                        ind++
                      ) {
                        for (
                          let shp = 0;
                          shp <
                          json.assets[b].layers[c].layers[e].layers[ind].shapes
                            .length;
                          shp++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].layers[ind]
                              .shapes[shp].nm === ShadeName
                          ) {
                            for (
                              let clrz = 0;
                              clrz <
                              json.assets[b].layers[c].layers[e].layers[ind]
                                .shapes[shp].it.length;
                              clrz++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].layers[ind]
                                  .shapes[shp].it[clrz].ty === "fl"
                              ) {
                                for (
                                  let clra = 0;
                                  clra < rbgConverted.length;
                                  clra++
                                ) {
                                  json.assets[b].layers[c].layers[e].layers[
                                    ind
                                  ].shapes[shp].it[clrz].c.k[clra] =
                                    rbgConverted[clra];
                                }
                                for (
                                  let cn = 0;
                                  cn <
                                  props.colorPickers.colorShades.ShadeName
                                    .length;
                                  cn++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].layers[
                                      ind
                                    ].shapes[shp].nm ===
                                    props.colorPickers.colorShades.ShadeName[cn]
                                  ) {
                                    let arr = [];

                                    for (let clrc = 0; clrc < 3; clrc++) {
                                      arr.push(rgbArray[clrc]);
                                    }

                                    props.colorPickers.colorShades.Shades[cn] =
                                      [];
                                    props.colorPickers.colorShades.Shades[cn] =
                                      arr;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else if (props.Gender === "Male") {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c].layers.length;
                    e++
                  ) {
                    if (json.assets[b].layers[c].layers[e].nm === Name) {
                      for (
                        let clry = 0;
                        clry < json.assets[b].layers[c].layers[e].shapes.length;
                        clry++
                      ) {
                        if (
                          json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                          ShadeName
                        ) {
                          for (
                            let clrz = 0;
                            clrz <
                            json.assets[b].layers[c].layers[e].shapes[clry].it
                              .length;
                            clrz++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[clry]
                                .it[clrz].ty === "fl"
                            ) {
                              for (
                                let clra = 0;
                                clra < rbgConverted.length;
                                clra++
                              ) {
                                json.assets[b].layers[c].layers[e].shapes[
                                  clry
                                ].it[clrz].c.k[clra] = rbgConverted[clra];
                              }
                              for (
                                let cn = 0;
                                cn <
                                props.colorPickers.colorShades.ShadeName.length;
                                cn++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].nm ===
                                  props.colorPickers.colorShades.ShadeName[cn]
                                ) {
                                  let arr = [];

                                  for (let clrc = 0; clrc < 3; clrc++) {
                                    arr.push(rgbArray[clrc]);
                                  }
                                  props.colorPickers.colorShades.Shades[cn] =
                                    [];
                                  props.colorPickers.colorShades.Shades[cn] =
                                    arr;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else if (
                PartsName[d] === "SideHair_Comp" ||
                PartsName[d] === "FrontHair_Comp" ||
                PartsName[d] === "BackHair_Comp"
              ) {
                for (
                  let e = 0;
                  e < json.assets[b].layers[c].layers.length;
                  e++
                ) {
                  if (json.assets[b].layers[c].layers[e].nm === Name) {
                    for (
                      let clry = 0;
                      clry < json.assets[b].layers[c].layers[e].shapes.length;
                      clry++
                    ) {
                      if (
                        json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                        ShadeName
                      ) {
                        for (
                          let clrz = 0;
                          clrz <
                          json.assets[b].layers[c].layers[e].shapes[clry].it
                            .length;
                          clrz++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].shapes[clry].it[
                              clrz
                            ].ty === "fl"
                          ) {
                            for (
                              let clra = 0;
                              clra < rbgConverted.length;
                              clra++
                            ) {
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].it[clrz].c.k[clra] = rbgConverted[clra];
                            }
                            for (
                              let cn = 0;
                              cn <
                              props.colorPickers.colorShades.ShadeName.length;
                              cn++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .nm ===
                                props.colorPickers.colorShades.ShadeName[cn]
                              ) {
                                let arr = [];

                                for (let clrc = 0; clrc < 3; clrc++) {
                                  arr.push(rgbArray[clrc]);
                                }
                                props.colorPickers.colorShades.Shades[cn] = [];
                                props.colorPickers.colorShades.Shades[cn] = arr;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  let varient = Name + "-Cap";

                  if (json.assets[b].layers[c].layers[e].nm === varient) {
                    for (
                      let clry = 0;
                      clry < json.assets[b].layers[c].layers[e].shapes.length;
                      clry++
                    ) {
                      if (
                        json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                        ShadeName
                      ) {
                        for (
                          let clrz = 0;
                          clrz <
                          json.assets[b].layers[c].layers[e].shapes[clry].it
                            .length;
                          clrz++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].shapes[clry].it[
                              clrz
                            ].ty === "fl"
                          ) {
                            for (
                              let clra = 0;
                              clra < rbgConverted.length;
                              clra++
                            ) {
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].it[clrz].c.k[clra] = rbgConverted[clra];
                            }
                          }
                        }
                      }
                    }
                  }
                }
                for (let c2 = 0; c2 < json.assets[b].layers.length; c2++) {
                  if (json.assets[b].layers[c2].nm === "EyeBrow_Comp") {
                    for (
                      let e = 0;
                      e < json.assets[b].layers[c2].layers.length;
                      e++
                    ) {
                      for (
                        let clry = 0;
                        clry <
                        json.assets[b].layers[c2].layers[e].shapes.length;
                        clry++
                      ) {
                        for (
                          let clrz = 0;
                          clrz <
                          json.assets[b].layers[c2].layers[e].shapes[clry].it
                            .length;
                          clrz++
                        ) {
                          if (
                            json.assets[b].layers[c2].layers[e].shapes[clry].it[
                              clrz
                            ].ty === "fl"
                          ) {
                            for (
                              let clra = 0;
                              clra < rbgConverted.length;
                              clra++
                            ) {
                              json.assets[b].layers[c2].layers[e].shapes[
                                clry
                              ].it[clrz].c.k[clra] = rbgConverted[clra];
                            }
                          }
                        }
                      }
                    }
                    break;
                  }
                }

                for (let c2 = 0; c2 < json.assets[b].layers.length; c2++) {
                  if (json.assets[b].layers[c2].nm === "Mouth_Comp") {
                    for (
                      let e = 0;
                      e < json.assets[b].layers[c2].layers.length;
                      e++
                    ) {
                      if(json.assets[b].layers[c2].layers[e].shapes != undefined) { 
                      for (
                        let clry = 0;
                        clry <
                        json.assets[b].layers[c2].layers[e].shapes.length;
                        clry++
                      ) {
                        if (
                          json.assets[b].layers[c2].layers[e].shapes[clry].nm ==
                          "Hair"
                        ) {
                          for (
                            let clrz = 0;
                            clrz <
                            json.assets[b].layers[c2].layers[e].shapes[clry].it
                              .length;
                            clrz++
                          ) {
                            if (
                              json.assets[b].layers[c2].layers[e].shapes[clry]
                                .it[clrz].ty === "fl"
                            ) {
                              for (
                                let clra = 0;
                                clra < rbgConverted.length;
                                clra++
                              ) {
                                json.assets[b].layers[c2].layers[e].shapes[
                                  clry
                                ].it[clrz].c.k[clra] = rbgConverted[clra];
                              }
                            }
                          }
                        }
                      }
                    }
                    }
                    break;
                  }
                }
              } else {
                for (
                  let e = 0;
                  e < json.assets[b].layers[c].layers.length;
                  e++
                ) {
                  if (json.assets[b].layers[c].layers[e].nm === Name) {
                    for (
                      let clry = 0;
                      clry < json.assets[b].layers[c].layers[e].shapes.length;
                      clry++
                    ) {
                      if (
                        json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                        ShadeName
                      ) {
                        for (
                          let clrz = 0;
                          clrz <
                          json.assets[b].layers[c].layers[e].shapes[clry].it
                            .length;
                          clrz++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].shapes[clry].it[
                              clrz
                            ].ty === "fl"
                          ) {
                            for (
                              let clra = 0;
                              clra < rbgConverted.length;
                              clra++
                            ) {
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].it[clrz].c.k[clra] = rbgConverted[clra];
                            }
                            for (
                              let cn = 0;
                              cn <
                              props.colorPickers.colorShades.ShadeName.length;
                              cn++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .nm ===
                                props.colorPickers.colorShades.ShadeName[cn]
                              ) {
                                let arr = [];

                                for (let clrc = 0; clrc < 3; clrc++) {
                                  arr.push(rgbArray[clrc]);
                                }
                                props.colorPickers.colorShades.Shades[cn] = [];
                                props.colorPickers.colorShades.Shades[cn] = arr;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var currFrame = props.Play.currentFrame;

    Lottie.destroy("alex");
    const ctx = document.getElementsByClassName("ChrClass")[0].getContext("2d");
    get2 = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: json,

      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
        //className: 'CharCanv',
      },
    });
    get2.goToAndPlay(currFrame, true, "alex");
    props.setPlay(get2);

    setrgba("rgb(" + rgbArray[0] + "," + rgbArray[1] + "," + rgbArray[2] + ")");
  };

  const AdvanceColor = (params) => {
    var color =
      "rgb(" +
      params.rgb["r"] +
      "," +
      params.rgb["g"] +
      "," +
      params.rgb["b"] +
      ")";
    if (props.TopActive === "Head") {
      CharClrChange(color, true);
    } else {
      partColor(color, true);
    }
  };

  const colorChng = (e) => {
    setrgba(e.rgb);
  };

  return (
    <>
      {ChrColorPicker && (
        <div
          key={props.keys.toString()}
          ref={focusDiv}
          tabIndex="1"
          // onLoad={setTimeout(() => {
          //     focusDiv.current.focus()
          // }, 200)}
          // onBlur={() => { setChrColorPicker(false);
          //     setAdvanceColors(false) }}
          style={{ position: "absolute", bottom: "100px", left: left + "px" }}
        >
          <div className="OptPopContainer2">
            {" "}
            <div className="OptInner2">
              <div className="boxUpper2">
                <div className="popTitle">Basic Colors</div>

                <span
                  className="material-icons"
                  style={{ padding: "3px 0px", cursor: "pointer" }}
                  onClick={() => {
                    setChrColorPicker(false);
                    setAdvanceColors(false);
                  }}
                >
                  close
                </span>
              </div>

              <div className="boxBottom">
                <div className="defaultColorsUpper">
                  <div className="defaultColors">
                    {props.TopActive === "Head" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => CharClrChange(event, false)}
                        ></div>
                      ))}
                    {props.TopActive === "Hair" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}
                    {props.TopActive === "Eyes" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}
                    {props.TopActive === "Shirts" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}
                    {props.TopActive === "Sweaters" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}
                    {props.TopActive === "Jackets" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}

                    {props.TopActive === "Bottoms" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          className="defaultColorsBlock"
                          style={{ backgroundColor: lmc.color }}
                          onClick={(event) => partColor(event)}
                        ></div>
                      ))}
                  </div>
                </div>
              </div>

              <div
                className="boxUpper2"
                onClick={() => {
                  if (AdvanceColors) {
                    setAdvanceColors(false);
                  } else {
                    setAdvanceColors(true);
                  }
                }}
              >
                <div className="popTitle">Advance Colors</div>

                {!AdvanceColors && (
                  <span
                    className="material-icons"
                    style={{ padding: "3px 0px", cursor: "pointer" }}
                    //  onClick={close}
                  >
                    expand_more
                  </span>
                )}

                {AdvanceColors && (
                  <span
                    className="material-icons"
                    style={{ padding: "3px 0px", cursor: "pointer" }}
                    //  onClick={close}
                  >
                    expand_less
                  </span>
                )}
              </div>

              {props.TopActive === "Head" && AdvanceColors && (
                <div className="boxBottom" style={{ userSelect: "none" }}>
                  
                  <Chrome
                   circleSize={100}
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                   
                  />
                </div>
              )}

              {props.TopActive === "Hair" && AdvanceColors && (
                <div className="boxBottom">
                    
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                   
                  />
                </div>
              )}

              {props.TopActive === "Eyes" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Shirts" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Sweaters" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Jackets" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Bottoms" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    onChange={colorChng}
                    disableAlpha={true}
                    onChangeComplete={AdvanceColor}
                    className="characterColor"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="charColorPicker">
        <div className="charColorPickerstart">
          {props.TopActive === "Head" && (
            <div className="ColorAreaName">Skin Color</div>
          )}
          {/* 
            {props.TopActive === 'Shirts' && (<div className='ColorAreaName'>Brand and Color</div>)} */}
          {props.TopActive === "Shirts" && (
            <div className="ColorAreaName">Color</div>
          )}

          {props.TopActive !== "Head" &&
            props.TopActive !== "Shirts" &&
            props.TopActive !== "Nose" &&
            props.TopActive !== "Body" &&
            props.TopActive !== "Mouth" && (
              <div className="ColorAreaName">Select Color</div>
            )}
          <div className="charColorBox">
            {/* {props.TopActive === 'Shirts' && (
                    <div className='charClrBox' style={{ padding: '2px', background: '#000' }}>
                        <span className="material-icons changeLogo">
                            upload
                        </span>
                    </div>
                )} */}

            {props.TopActive !== "Nose" &&
              props.TopActive !== "Body" &&
              props.TopActive !== "Mouth" &&
              props.colorPickers.colorShades.ShadeName.map((lmc, index) => (
                <div
                  key={index}
                  className="charClrBox"
                  style={{ padding: "5px" }}
                  onClick={(event) =>
                    openpicker(
                      event,
                      lmc,
                      Math.round(
                        props.colorPickers.colorShades.Shades[index][0]
                      ),
                      Math.round(
                        props.colorPickers.colorShades.Shades[index][1]
                      ),
                      Math.round(
                        props.colorPickers.colorShades.Shades[index][2]
                      )
                    )
                  }
                >
                  <div
                    className="charClrBoxInner"
                    style={{
                      background:
                        "rgba(" +
                        Math.round(
                          props.colorPickers.colorShades.Shades[index][0]
                        ) +
                        "," +
                        Math.round(
                          props.colorPickers.colorShades.Shades[index][1]
                        ) +
                        "," +
                        Math.round(
                          props.colorPickers.colorShades.Shades[index][2]
                        ) +
                        ",1)",
                    }}
                  ></div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PopColorPicker;
